import { Component, OnInit, Input, DoCheck, ElementRef, Output, EventEmitter, ViewChild, HostListener } from '@angular/core';
import {
  CfetBaseComponent, CFETILMEndpointsConstant, CfetService, ErrorService, CfetErrorMessagesConstant,
  UrlUtil, CfetPageNamesConstant
} from '../../../cfet-core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import moment from 'moment';
import { environment } from './../../../../environments/environment';
import { Router } from '@angular/router';
import { LocationStrategy, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef } from '@angular/core';
import { SheerIdApiIntegrationPayload } from 'src/app/interface-models/sheer-id-api-interface';
import { SheeridApiService } from 'src/app/cfet-core/core-services/sheeridapiservice.service';
import { CFETILMSheerIdApiConstant } from 'src/app/cfet-core/constants/cfet-ilm-sheerid-api.constant';

@Component({
    selector: 'app-customer-information-form-utf',
    templateUrl: './customer-information-form-utf.component.html',
    styleUrls: ['./customer-information-form-utf.component.scss'],
    standalone: false
})
export class CustomerInformationFormUtfComponent extends CfetBaseComponent implements OnInit, DoCheck {

  @Input() selectedWorkPlace: string;
  @Output() hideEditButton = new EventEmitter<any>();
  @Output() goToInstantVerification = new EventEmitter<any>();
  @ViewChild('inputEmail') inputEmail: ElementRef<HTMLInputElement>;
  @Output() hideSessionTimeout = new EventEmitter<any>(false);
  @Output() showCancelModal = new EventEmitter<any>();
  @Output() progressTrackerEvent = new EventEmitter<any>();
  @Output() clearSessionTimeout = new EventEmitter<any>(false);

  personalInformationFormGroup: UntypedFormGroup;
  firstName: UntypedFormControl;
  middleName: UntypedFormControl;
  lastName: UntypedFormControl;
  address1Value: UntypedFormControl;
  address2Value: UntypedFormControl;
  cityValue: UntypedFormControl;
  stateValue: UntypedFormControl;
  zipCode: UntypedFormControl;
  mobilenumber: UntypedFormControl;
  dateOfBirth: UntypedFormControl;
  emailAddress: UntypedFormControl;
  workEmailAddress: UntypedFormControl;
  workidnumber: UntypedFormControl;
  domainList: any = [];
  domainValueOption: any;
  approvedDomainsCache: any = {};
  stateValueOption: any;
  stateList: any[] = [];
  getData: any;
  timeZoneList = [];
  timeZoneData: Array<any> = [];
  timeZoneValue = { value: '', text: 'Select' };
  checkState: any;
  currentyear: any;
  currentday: any;
  currentmonth: any;
  returnUrl = '';
  disabledSubmitButton = true;
  showPersonalEmailDesc = false;
  showWorkEmail = false;
  showPersonalInfoSection = true;
  showInstantVerificationSection = false;
  showDocUploadSection = false;
  showVerificationNotRequired = false;
  showWorkIdNumberinput = false;
  yesButton: boolean;
  noButton: boolean;
  OpenInfo = false;
  OpenPersonalDetails = true;
  OpenOrgInfo = false;
  OpenOrgDetails = true;

  workDept: any;
  selectedEmpVolButton: any;
  selectedEmpIdButton: any;
  phoneNumberError: boolean;
  dropdowndefaultValue = true;
  isValidDob = true;
  emailAddressEmpty: any;
  emailAddressError: any;
  workEmailAddressError: boolean;
  workIdError: boolean;
  isValidFirstName = true;
  isValidLastName = true;
  personalAddressError: boolean;
  cityError: boolean;
  zipcodeError: boolean;
  stateError: boolean;
  selectedconfirmValue: any;
  hasWorkId: boolean;
  selectedfedEmployee: any;
  isFedEmployee: boolean;
  customerAge: any;
  dobAbove16: boolean;
  email: '';
  geteligibilityInfo: any;
  entity: any;
  status: any;
  type: any;
  respondertypes: any;
  responderTypes: any;
  profileData: any;
  jobfunction: any;
  programId: any;
  residentialAdd: any;
  showVerificationPending = false;
  fname: any;
  lname: any;
  showDocReviewPending = false;
  emailAlreadyExists = false;
  showLoading = false;
  orgIdSelected: any;
  errorMessage: string = "";
  stateData: Array<any> = [];
  spaTerritories: Array<any> = [];
  retailAgentGroup: string;
  organizationInfo: {};
  affiliationCode: string;
  codeOrgDetails: string;
  organizationid: any;
  isWorkEmailMandatory = false;
  organisationName: any;
  retailFanAccountList: any;
  fanName: any;
  selectedValue = {
    fan: ''
  };
  isSpaOrg: any;
  // RapidSOS orgs can have an empty affiliationCode (no retCode), so this flag identifies them independently.
  isRapidSosOrg = false;
  selectedagencyInfo: any;
  createUserSuccess: boolean;
  tempverificationStatus: string;
  attributeMap: any;
  sheeridCurrentStep: any;
  fName: any;
  lName: any;
  emailVerified: any;
  httpHeaders: any = {};
  httpUtfHeaders: any = {};
  userid: any;
  userType: any;
  subType: any;
  url: any;
  openCancelModal = '';
  showBeforeSheerIDCancelModal = false;
  displayUserID = false;
  userID: any;
  attID: any;
  attEmail: any;
  altEmail: any;
  contactEmail: any;
  singleIdForm: any;
  separateIDValues: any;
  separateID: any;
  showSeparateIdForm: any;
  showSingleIdPage: any;
  accessMitigation = false;
  eligibilityCompletion = false;
  linkcuser = '';
  fieldTabbed: boolean = false;
  territoryStates: any = [];
  premierTerritories: any = [];
  displaySearchResult: boolean;
  addressList: any;
  domainValue: UntypedFormControl;
  noResultFound: boolean;
  accessToken: any;
  attCustomerExists: boolean = false;
  ahora: any;
  ultimaEjecucion = 0;

  errorReturnLink = {
    anchorLink: CfetPageNamesConstant.UTF_REGISTRATION,
    anchorText: 'Go Back'
  };
  oraInformation: { ora_required: string; ora_required_attributes: string[] };
  agencyNameSource: string;
  selectedDomain: any;
  sheerIdCurrentStepVerificationUrl: string;
  constructor(private elementRef: ElementRef,
    private router: Router,
    private urlUtil: UrlUtil,
    private cfetService: CfetService,
    private locationStrategy: LocationStrategy,
    private location: Location,
    private cd: ChangeDetectorRef,
    private errorService: ErrorService,
    private http: HttpClient, private readonly sheeridApiService: SheeridApiService) {
    super();
    history.pushState(null, null, window.location.href);
    // to check if back or forward button is pressed.
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.ensureAgencyName();
    this.firstName = new UntypedFormControl({ value: '', disabled: true }, { validators: [Validators.required], updateOn: 'change' });
    this.middleName = new UntypedFormControl('', [Validators.required]);
    this.lastName = new UntypedFormControl({ value: '', disabled: true }, { validators: [Validators.required], updateOn: 'change' });
    this.dateOfBirth = new UntypedFormControl('', [Validators.required]);
    this.emailAddress = new UntypedFormControl('', [Validators.required]);
    this.workEmailAddress = new UntypedFormControl('');
    this.workidnumber = new UntypedFormControl('', { validators: [Validators.minLength(4)], updateOn: 'change' });
    this.mobilenumber = new UntypedFormControl('', { validators: [Validators.required], updateOn: 'change' });
    this.address1Value = new UntypedFormControl('', { validators: [Validators.required], updateOn: 'change' });
    this.address2Value = new UntypedFormControl('', [Validators.required]);
    this.cityValue = new UntypedFormControl('', { validators: [Validators.required] });
    this.domainValue = new UntypedFormControl('', [Validators.required]);
    this.stateValue = new UntypedFormControl('', [Validators.required]);
    this.zipCode = new UntypedFormControl('', { validators: [Validators.required, Validators.minLength(5)], updateOn: 'change' });
    this.personalInformationFormGroup = new UntypedFormGroup({
      firstName: this.firstName,
      middleName: this.middleName,
      lastName: this.lastName,
      dateOfBirth: this.dateOfBirth,
      mobilenumber: this.mobilenumber,
      emailAddress: this.emailAddress,
      workEmailAddress: this.workEmailAddress,
      workidnumber: this.workidnumber,
      address1Value: this.address1Value,
      address2Value: this.address2Value,
      cityValue: this.cityValue,
      stateValue: this.stateValue,
      zipCode: this.zipCode,
      domainValue: this.domainValue
    });
    this.errorService.showError.next(false);
    sessionStorage.setItem('fnStatus', 'fnStatus=ineligible');
    // Authenticated flow - use single id (valid userID)
    this.getSessionDetails();

    // Hide/Show the email id inputbox to show the userid prepopulation
    if (this.userID !== '' && this.userID !== undefined && this.userID !== null) {
      this.displayUserID = true;
      this.emailAddressError = false;
      this.emailAddressEmpty = false;
    } else {
      this.displayUserID = false;
    }
    // State list dropdown population
    this.stateValueOption = { 'value': 'Select', 'text': 'Select' };
    this.stateList = [];
    const commonListValues = JSON.parse(sessionStorage.getItem('ngStorage-commonListValues'));
    this.stateData = commonListValues['validStates'];
    this.spaTerritories = commonListValues['validSPATerritories'];
    this.timeZoneData = commonListValues['validTimeZones'];
    if (this.timeZoneData && this.timeZoneData.length > 0) {
      this.timeZoneList = this.timeZoneData.map(t => {
        return { value: t, text: t };
      });
    }
    Object.keys(this.spaTerritories).forEach((key) => {
      let val = this.spaTerritories[key];
      this.stateData = this.stateData.concat(val);
      if (key == 'PremierD&S') {
        this.territoryStates = this.territoryStates.concat(val);
      }
    });
    this.stateData.sort();
    if (this.territoryStates && this.territoryStates.length > 0) {
      this.premierTerritories = this.territoryStates.map(ele => {
        return ele ? ele : '';
      });
    }
    if (this.stateData && this.stateData.length > 0) {
      this.stateList = this.stateData.map(
        stateValue => {
          const state = stateValue ? stateValue.split(':')[1] : '';
          return { value: stateValue, text: state };
        });
    }
    this.workDept = this.selectedWorkPlace;
    const currentdate = new Date();
    this.currentyear = currentdate.getFullYear();
    this.currentmonth = currentdate.getMonth() + 1;
    this.currentday = currentdate.getDate();
    this.getSessionOrg();
    this.getSessionEligbility();
    this.domainsList();
    setTimeout(() => {
      const oraInformationString = sessionStorage.getItem('oraInformation');
      console.log("ORA IN INIT:", this.oraInformation);
      this.oraInformation = oraInformationString ? JSON.parse(oraInformationString) : null;
      this.cd.detectChanges(); // 🔥 FORCE UI UPDATE
    }, 100);
    // const agencyNameInfo = sessionStorage.getItem('agencyNameSource');
    // console.log('this.agencyNameSource1:', this.agencyNameSource);
    // if (agencyNameInfo === 'userManualEntry') {
    //   this.agencyNameSource = 'User Entry';
    // }
    // else if (agencyNameInfo === 'userSearchResult') {
    //   this.agencyNameSource = 'ILM DB';
    // }
    // else if (agencyNameInfo === 'fuzzyAI') {
    //   this.agencyNameSource = 'AI Search';
    // }
    // else {
    //   this.agencyNameSource = null;
    // }
    //console.log('this.agencyNameSource2:', this.agencyNameSource);
    console.log("Oraenabled", this.isOraEnabled());
  }

  // for capturing the browser back button event
  @HostListener('window: popstate', ['$event'])
  onPopState(event: Event): void {
    event.preventDefault();
    if (this.showPersonalInfoSection) {
      this.goBack({ key: 'Enter' });
    } else {
      this.location.back();
    }
    window.scrollTo(0, 0);
  }

  @HostListener('keyup', ['$event']) onKeyUp(e) {
    if (e.key == "Tab" && e.keyCode == 9) {
      this.fieldTabbed = true;
    } else {
      this.fieldTabbed = false;
    }
  }
  @HostListener('document:click', ['$event']) ondivBlur(event) {
    if (event && event.target && (event.target.id !== 'address1' && event.target.id !== 'search-result'
      && event.target.id !== 'address-field-list' && event.target.id !== 'workplace-link' && event.target.id !== 'manually-enter')) {
      this.displaySearchResult = false;
      this.noResultFound = false;
    }
  }

  @HostListener('keyup', ['$event']) ondivFocus(event) {
    if (event && event.target && event.keyCode === 9 && (event.target.id !== 'address1' && event.target.id !== 'search-result'
      && event.target.id !== 'address-field-list' && event.target.id !== 'workplace-link' && event.target.id !== 'manually-enter' && event.target.id !== 'address-field-details' && event.target.id !== 'gray-text')) {
      this.displaySearchResult = false;
      this.noResultFound = false;
    }
  }

  ngDoCheck() {
    const workEmailValueEntered = this.workEmailAddress.value && this.workEmailAddress.value.trim() !== '';
    this.ahora = Date.now();
    if (this.ahora - this.ultimaEjecucion >= 30000) {
      this.ultimaEjecucion = this.ahora;
    }

    this.disabledSubmitButton =
      (this.firstName.value === undefined
        || this.firstName.value === ''
        || this.lastName.value === undefined
        || this.lastName.value === ''
        || this.isValidFirstName === false
        || this.isValidLastName === false
        || (this.emailAddressError === undefined || this.emailAddressError)
        || (this.emailAddressEmpty === undefined || this.emailAddressEmpty)
        || (this.emailAlreadyExists === undefined || this.emailAlreadyExists)
        || (this.userID && this.userID === undefined)
        || (this.phoneNumberError === undefined || this.phoneNumberError)
        || (this.isValidDob === false || this.dobAbove16 === true || this.dateOfBirth.value === '')
        || (this.personalAddressError === undefined || this.personalAddressError)
        || (this.stateValue.value === '' || this.stateValue.value === 'Select')
        || (this.cityError === undefined || this.cityError)
        || (this.zipcodeError === undefined || this.zipcodeError)
        // Work email validation condition:
        || (!this.isWorkEmailOptional() && !workEmailValueEntered)
        || this.workEmailAddressError === true || this.workIdError === true || this.attCustomerExists === true
        || this.workidnumber.invalid
        || !(
          (this.isDomainListEmpty()) || // No domains at all - enable submit
          (this.domainList && this.domainList.length > 0 && this.domainValue.value) // domains exist and a domain is selected
        )
      );
  }

  getSessionOrg() {
    if (sessionStorage.getItem('orgInfo') && Object.keys(sessionStorage.getItem('orgInfo')).length !== 0) {
      this.codeOrgDetails = JSON.parse(sessionStorage.getItem('orgInfo'));
      this.isSpaOrg = this.codeOrgDetails['isSpaOrg'];
      this.affiliationCode = this.codeOrgDetails['affiliationCode'];
      this.isRapidSosOrg = !!this.codeOrgDetails['isRapidSOS'];
    }
  }
  getSessionEligbility() {
    if (sessionStorage.getItem('eligibilityInfo') && Object.keys(sessionStorage.getItem('eligibilityInfo')).length !== 0) {
      this.geteligibilityInfo = JSON.parse(sessionStorage.getItem('eligibilityInfo'));
      this.selectedagencyInfo = this.geteligibilityInfo.eligibilityStatus;
      console.log('[CustomerInfoUTF] READING eligibilityInfo on init', this.geteligibilityInfo);
      console.log('[CustomerInfoUTF] eligibilityStatus (selectedagencyInfo)', this.selectedagencyInfo);
      this.entity = this.geteligibilityInfo.entity;
      this.status = this.geteligibilityInfo.status;
      this.type = this.geteligibilityInfo.type;
      this.userType = this.geteligibilityInfo.userType;
      this.subType = this.geteligibilityInfo.subType;
      this.jobfunction = this.geteligibilityInfo.selectedRole;
    } else {
      console.log('[CustomerInfoUTF] eligibilityInfo NOT FOUND in sessionStorage on init');
    }
  }
  getSessionDetails() {
    if (sessionStorage.getItem('ngStorage-singleIDInfo') && Object.keys(sessionStorage.getItem('ngStorage-singleIDInfo')).length !== 0) {
      this.httpHeaders = JSON.parse(sessionStorage.getItem('ngStorage-singleIDInfo'));
      this.attID = this.httpHeaders.attID;
      this.contactEmail = (this.httpHeaders.contactEmail === 'NOT_FOUND') ? this.httpHeaders.attEmail : this.httpHeaders.contactEmail;
      this.emailVerified = this.httpHeaders.emailVerified;
      this.userID = this.httpHeaders.attEmail;
      this.fName = this.httpHeaders.fName;
      this.lName = this.httpHeaders.lName;
      this.attEmail = this.httpHeaders.attEmail;
      this.accessToken = this.httpHeaders.accessToken;
    }
    this.getUnauthFlowDetails();
    this.getSingleIDDetails();
    this.getSSValues();

    if (!this.fName || this.fName === "") {
      this.personalInformationFormGroup.get("firstName").enable();
    }
    if (!this.lName || this.lName === "") {
      this.personalInformationFormGroup.get("lastName").enable();
    }
  }

  getUnauthFlowDetails() {
    // Unauthenticated flow
    if ((sessionStorage.getItem('userID') && Object.keys(sessionStorage.getItem('userID')).length !== 0) ||
      (sessionStorage.getItem('unAuth') && Object.keys(sessionStorage.getItem('unAuth')).length !== 0)) {
      if (sessionStorage.getItem('userID') !== 'undefined' && sessionStorage.getItem('userID') !== undefined) {
        this.userID = JSON.parse(sessionStorage.getItem('userID'));
      }
      this.accessMitigation = JSON.parse(sessionStorage.getItem('unAuth'));
    }
  }

  getSingleIDDetails() {
    // If it's UTF Compatible but not in email id format - we use different email id
    if ((sessionStorage.getItem('singleIdForm') && Object.keys(sessionStorage.getItem('singleIdForm')).length !== 0)) {
      this.singleIdForm = JSON.parse(sessionStorage.getItem('singleIdForm'));
      if (this.singleIdForm !== '' && this.singleIdForm !== undefined && this.singleIdForm !== null) {
        this.userID = this.singleIdForm.newEmail;
        this.fName = this.singleIdForm.fName;
        this.lName = this.singleIdForm.lName;
        this.altEmail = this.singleIdForm.contactEmail;
        this.attEmail = this.singleIdForm.attEmail;
      }
    }
  }

  getSSValues() {
    // If we use a separate email id - Keep ids separate
    this.seperateId();
  }

  seperateId() {
    if ((sessionStorage.getItem('separateIDValues') && Object.keys(sessionStorage.getItem('separateIDValues')).length !== 0)) {
      this.separateIDValues = JSON.parse(sessionStorage.getItem('separateIDValues'));
      if (this.separateIDValues !== '' && this.separateIDValues !== undefined && this.separateIDValues !== null) {
        this.separateID = this.separateIDValues.separateID;
        this.userID = this.separateIDValues.userID;
        this.attEmail = this.separateIDValues.attEmail;
        this.fName = this.separateIDValues.firstName;
        this.lName = this.separateIDValues.lastName;
      }
    }
    if (sessionStorage.getItem('AMUTFHeaders') && Object.keys(sessionStorage.getItem('AMUTFHeaders')).length !== 0) {
      this.httpUtfHeaders = JSON.parse(sessionStorage.getItem('AMUTFHeaders'));
    }
  }

  loadNonFedAttributes() {
    if (!sessionStorage.getItem('ngStorage-attributeMap') || Object.keys(sessionStorage.getItem('ngStorage-attributeMap')).length === 0) {
      this.cfetService.cfetLoadNonFederatedAttributes().subscribe((nonFedData) => {
        this.attributeMap = nonFedData;
        sessionStorage.setItem('ngStorage-attributeMap', JSON.stringify(this.attributeMap));
      },
        (error) => {
          this.errorMessage = this.cfetMessages.official_doc_system_error;
          this.errorService.displayErrorMessage(this.errorMessage);
        });
    } else {
      this.attributeMap = JSON.parse(sessionStorage.getItem('ngStorage-attributeMap'));
    }
  }

  onChangeState(event) {
    this.checkState = '';
    this.stateValue.setValue(event.value);
    if (this.stateValue.value !== 'select') {
      this.dropdowndefaultValue = false;
      if (screen.width > 1024) {
        const inputelem1 = this.elementRef.nativeElement.querySelector('#select_state');
        inputelem1.setAttribute('style', 'color : #333 !important');
      } else {
        const inputelem1 = this.elementRef.nativeElement.querySelector('#select_state').nextElementSibling;
        inputelem1.setAttribute('style', 'color : #333 !important');
      }
    } else {
      this.dropdowndefaultValue = true;
      const inputelem1 = this.elementRef.nativeElement.querySelector('#select_state');
      inputelem1.setAttribute('style', 'color : #868585 !important');
    }
  }

  onClickState(event) {
    if (event.target.ariaExpanded === 'true') {
      this.checkState = 'dropdown-opened';
    } else {
      this.checkState = '';
    }
  }

  checkFirstname() {
    const regexpName = new RegExp(/^([A-Z0-9a-z\s\'\-]{2,})$/);
    this.isValidFirstName = regexpName.test(this.firstName.value.trim());
  }

  checkLastname() {
    const regexpName = new RegExp(/^([A-Z0-9a-z\s\'\-]{2,})$/);
    this.isValidLastName = regexpName.test(this.lastName.value.trim());
  }

  checkAddress() {
    this.personalAddressError = this.address1Value.value.length > 1 ? false : true;
  }

  checkCity() {
    this.cityError = this.cityValue.value.length > 1 ? false : true;
  }

  checkStateFn() {
    this.stateError = this.stateValue.value === 'Select' ? true : false;
  }

  checkWorkId() {
    this.workIdError = (this.workidnumber.value.length >= 4 || this.workidnumber.value.length == 0) ? false : true;
  }

  checkZip() {
    this.zipCode.value.replace(/\D/g, '');
    this.zipCode.setValue(this.zipCode.value.replace(/\D/g, ''));
    this.zipcodeError = this.zipCode.value.length < 5 ? true : false;
  }

  selectDomain(event: { value: string; text: string }) {
    this.domainValue.setValue(event.value);
    this.domainValueOption = { 'value': event.value, 'text': event.text };
  }

  checkPhoneNumber() {
    this.phoneNumberError =
      (this.mobilenumber.value === '' || (this.mobilenumber.value && this.mobilenumber.value.toString().length > 0 &&
        (this.mobilenumber.value.toString().length < 10 || this.mobilenumber.value.toString().length === 11))) ? true : false;
  }

  formatDOB(e) {
    const date = this.dateOfBirth.value;
    const datenoslash = this.dateOfBirth.value.replace('/', '');
    if (this.dateOfBirth.value && this.dateOfBirth.value.length >= 2 && !isNaN(datenoslash) && this.dateOfBirth.value.indexOf('/') === -1
      && (e.keyCode !== 8 || e.key.toLowerCase() !== 'backspace')) {
      this.dateOfBirth.setValue(date.slice(0, 2).concat('/'));
    }
    if (this.dateOfBirth.value && this.dateOfBirth.value.length === 4 && !isNaN(datenoslash) && this.dateOfBirth.value.indexOf('/') === 1
      && this.dateOfBirth.value.lastIndexOf('/') !== 3 && (e.keyCode !== 8 || e.key.toLowerCase() !== 'backspace')) {
      this.dateOfBirth.setValue(date.slice(0, 4).concat('/') + date.slice(5));
    }
    if (this.dateOfBirth.value && this.dateOfBirth.value.length > 4 && !isNaN(datenoslash) && this.dateOfBirth.value.indexOf('/') !== 1
      && (e.keyCode !== 8 || e.key.toLowerCase() !== 'backspace')) {
      if (this.dateOfBirth.value.lastIndexOf('/') === 3 || this.dateOfBirth.value.lastIndexOf('/') === 4) {
        this.dateOfBirth.setValue(date);
      } else {
        this.dateOfBirth.setValue(date.slice(0, 5).concat('/') + date.slice(6));
      }
    }
  }

  checkDOB() {
    this.customerAge = '';
    this.isValidDob = moment(this.dateOfBirth.value, ['MM/DD/YYYY', 'M/D/YYYY'], true).isValid();
    if (this.isValidDob) {
      this.dateOfBirth.setValue(moment(this.dateOfBirth.value).format('MM/DD/YYYY'));
      this.customerAge = moment().diff(this.dateOfBirth.value, 'years', false);
      this.dobAbove16 = this.customerAge < 16;
      if (this.dobAbove16) {
        this.OpenPersonalDetails = true;
      }
    }
  }

  autoPopulateAPI() {
    if (this.address1Value.value && this.address1Value.value.length >= 2) {
      const addressAPI = CFETILMEndpointsConstant.addresspopulateAPI + '?search=' + this.address1Value.value.replace(' ', '+') + '&auth-id=' + environment.authId + '&max_results=10';
      const addressPopulatexhr = new XMLHttpRequest();
      // address status xhr - new http request
      addressPopulatexhr.open('GET', addressAPI);
      // address status get call
      addressPopulatexhr.send();
      // send the call
      addressPopulatexhr.onreadystatechange = () => {
        if (addressPopulatexhr.response && addressPopulatexhr.readyState === 4 && addressPopulatexhr.status === 200) {
          const addressResponse = JSON.parse(addressPopulatexhr.response);
          if (addressResponse && addressResponse.suggestions && addressResponse.suggestions.length > 0) {
            this.displaySearchResult = true;
            this.addressList = addressResponse.suggestions;
          } else {
            this.noResultFound = true;
            this.displaySearchResult = false;
          }
        }
        else {
          this.displaySearchResult = false;
          this.noResultFound = false;
        }
      }
    } else {
      this.displaySearchResult = false;
      this.noResultFound = false;
    }

    /* let addressResponseurl : any= `${environment.getApiLiveUrl()}${CFETILMEndpointsConstant.addresspopulateAPItest}`;

    this.http.get(addressResponseurl).subscribe(data =>{
      console.log(data);
      let addressResponse : any = data;
      if (addressResponse && addressResponse.suggestions && addressResponse.suggestions.length > 0) {
        this.displaySearchResult = true;
        this.addressList = addressResponse.suggestions;
      } else {
        this.noResultFound = true;
        this.displaySearchResult = false;
      }
    })
  }else {
    this.displaySearchResult = false;
    this.noResultFound = false;
  } */
  }

  onChangeaddress(event, row) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.displaySearchResult = false;
      this.address1Value.setValue(row.street_line);
      this.address2Value.setValue(row.secondary);
      this.cityValue.setValue(row.city);
      this.setStateValue(row);
      this.zipCode.setValue(row.zipcode);
      this.cityError = this.cityValue.value.length > 1 ? false : true;
      this.stateError = this.stateValue.value === 'Select' ? true : false;
      this.zipcodeError = this.zipCode.value.length < 5 ? true : false;
      this.updateTimezone(row);
    }
  };

  updateTimezone(row) {
    const timezoneAPI = CFETILMEndpointsConstant.timezoneAPI + '/street-address?auth-id=' + environment.authId + "&street=" + row.street_line.replace(/ /g, '+') + '&city=' + row.city.replace(/ /g, '+') + '&state=' + row.state + '&zipcode=' + row.zipcode + '&candidates=1';
    console.log("timezoneapi: " + timezoneAPI);
    const timezonePopulatexhr = new XMLHttpRequest();
    timezonePopulatexhr.open('GET', timezoneAPI);
    timezonePopulatexhr.send();
    timezonePopulatexhr.onreadystatechange = () => {
      if (timezonePopulatexhr.response && timezonePopulatexhr.readyState === 4 && timezonePopulatexhr.status === 200) {
        const timezoneResponse = JSON.parse(timezonePopulatexhr.response);
        if (timezoneResponse[0].metadata.time_zone) {
          this.timeZoneList.forEach(ele => {
            if (ele.value.includes(timezoneResponse[0].metadata.time_zone)) {
              this.timeZoneValue = ele;
              localStorage.setItem('timezone', this.timeZoneValue.text);
            }
          })
        }
      }
    }

    /* let timezoneResponseurl : any= `${environment.getApiLiveUrl()}${CFETILMEndpointsConstant.timezoneAPItest}`;
    this.http.get(timezoneResponseurl).subscribe(data =>{
      let timezoneresponse : any = data;
      if (timezoneresponse[0].metadata.time_zone){
        this.timeZoneList.forEach(ele => {
          if (ele.value.includes(timezoneresponse[0].metadata.time_zone)){
            this.timeZoneValue= ele;
             console.log("time: "+this.timeZoneValue);
            localStorage.setItem('timezone', this.timeZoneValue.text);
          }
        })
      }
    }) */
  }

  @HostListener('document:click', ['$event'])
  documentClick(event: Event): void {
    this.displaySearchResult = false;
    this.noResultFound = false;
  }


  keyDownHandler(event: any) {
    if (event.which === 32 && event.target.selectionStart === 0) {
      event.preventDefault();
    }
  }
  pasteHandler(event: any) {
    let value = event.clipboardData.getData('text/plain');
    value = value.trim();
    event.currentTarget.value = value;
    event.preventDefault();
  }


  setStateValue(row) {
    if (this.stateData && row.state) {
      this.stateData.forEach(stateElem => {
        if (stateElem && stateElem.split(':')[0] === row.state) {
          this.stateValueOption = { 'value': stateElem, 'text': stateElem.split(':')[1] };
          this.stateValue.setValue(stateElem);
        }
      });
    }
  }



  goBack(event) {
    const isSpaTerriroryState = sessionStorage.getItem('isSpaTerriroryState');
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      if (this.attID && (this.contactEmail || this.httpHeaders.attEmail)) {
        this.showSingleIdPage = false;
        sessionStorage.removeItem('separateId');
        sessionStorage.setItem('showSingleIdPage', JSON.stringify(this.showSingleIdPage));
        const url = environment.getBrowserPath() + CfetPageNamesConstant.UTF_AUTH_SINGLE_ID_PAGE
          + '?firstname=' + this.fName + '&lastname=' + this.lName +
          '&email=' + this.userID + '&isEmailVerified=' + this.emailVerified + '&userid=' + this.userID + '&accessToken=' + this.accessToken;
        this.redirectUrl(url);
      } else if (this.userID && this.altEmail) {
        const altSingleId = {
          'altEmail': true,
          'userID': this.userID
        };
        sessionStorage.setItem('altSingleId', JSON.stringify(altSingleId));
        const url = environment.getBrowserPath() + CfetPageNamesConstant.UTF_AUTH_SINGLE_ID_PAGE;
        this.redirectUrl(url);
      } else if (this.userID && this.separateID) {
        const separateId = {
          'showSeparateIdForm': true,
          'userID': this.userID,
          'attEmail': this.attEmail
        };
        sessionStorage.setItem('AMUTFHeaders', JSON.stringify(this.httpUtfHeaders));
        sessionStorage.setItem('separateId', JSON.stringify(separateId));
        const url = environment.getBrowserPath() + CfetPageNamesConstant.UTF_AUTH_SINGLE_ID_PAGE;
        this.redirectUrl(url);
      } else if (this.userID && this.accessMitigation) {
        sessionStorage.setItem('userID', JSON.stringify(this.userID));
        const url = environment.getBrowserPath() + CfetPageNamesConstant.UTF_UNAUTH_PAGE;
        this.redirectUrl(url);
      } else if (environment.hideRegistrationPage || isSpaTerriroryState) {
        const eligibilitySignUp = {
          'showWorkplace': true
        };
        sessionStorage.setItem('eligibilty-signup', JSON.stringify(eligibilitySignUp));
        const url = environment.getBrowserPath() + CfetPageNamesConstant.CUSTOMER_ELIGIBILITY_UTF;
        this.redirectUrl(url);
      } else {
        this.router.navigate([
          CfetPageNamesConstant.CUSTOMER_ELIGIBILITY_UTF,
          'completion'
        ]);
      }
    }
  }

  validateEmailAddress(emailType) {
    const emailRegex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/);
    if (emailType === 'personal') {
      if (this.emailAddress.value === '' || this.emailAddress.value === undefined) {
        this.emailAddressEmpty = true;
      } else {
        this.showPersonalEmailDesc = true;
        this.emailAddressEmpty = false;
        this.emailAddressError = !emailRegex.test(this.emailAddress.value);
      }
    }
    if (emailType === 'work') {
      this.workEmailAddressError = this.workEmailAddress.value === '' ? false : !emailRegex.test(this.workEmailAddress.value);
    }
  }

  onChangeEmail() {
    this.emailAlreadyExists = false;
  }

  hasWorkEmail(event, type) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      if (type === 'yes') {
        this.yesButton = true;
        this.noButton = false;
        this.selectedconfirmValue = 'Yes';
        this.showWorkEmail = true;
      }
      if (type === 'no') {
        this.noButton = true;
        this.yesButton = false;
        this.selectedconfirmValue = 'No';
        this.showWorkEmail = false;
        this.workEmailAddressError = false;
        this.workEmailAddress.setValue('');
      }
    }
  }

  hasWorkIDNumber(event, type) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      if (type === 'yes') {
        this.selectedEmpIdButton = 'Yes';
        this.hasWorkId = true;
        this.showWorkIdNumberinput = true;
      }
      if (type === 'no') {
        this.hasWorkId = false;
        this.selectedEmpIdButton = 'No';
        this.showWorkIdNumberinput = false;
        this.workIdError = false;
        this.workidnumber.setValue('');
      }
    }
  }

  setNewValues() {
    const agencyName = sessionStorage.getItem('agencyName');
    const agencyNameSource = sessionStorage.getItem('agencyNameSource');
    sessionStorage.setItem('contactCTN', this.mobilenumber.value);
    console.log('FINAL AGENCY VALUES BEFORE SAVE:', {
      agencyName,
      agencyNameSource
    });
    return {
      'action': 'Personal Information',
      'firstname': this.firstName.value.trim(),
      'middlename': this.middleName.value ? this.middleName.value : '',
      'lastname': this.lastName.value.trim(),
      'emailaddress': this.emailAddress.value && this.emailAddress.value !== '' ? this.emailAddress.value : this.userID,
      'attID': this.userID && this.userID !== '' ? this.userID : '',
      'ctn': this.mobilenumber.value,
      'dob': this.dateOfBirth.value,
      'address1': this.address1Value.value,
      'address2': this.address2Value.value ? this.address2Value.value : '',
      'city': this.cityValue.value,
      'state': this.stateValue.value,
      'zipCode': this.zipCode.value,
      'workemail': this.workEmailAddress.value ? this.workEmailAddress.value : '',
      'workid': this.workidnumber.value ? this.workidnumber.value : '',
      'empOrVol': this.selectedEmpVolButton,
      'yesOrNoClicked': this.selectedconfirmValue,
      'workId': this.hasWorkId,
      'agencyEmail': this.workEmailAddress.value.trim() + '@' + this.domainValue.value.trim(),
      'agencyName': agencyName || null,
      'agencyNameSource': agencyName ? agencyNameSource : null
    };
  }

  findUserId() {
    return (this.emailAddress.value && this.emailAddress.value !== '') ? this.emailAddress.value.trim() : this.userID.trim();
  }

  submit(event) {
    console.log("customer-information-form-utf - submit: start");
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      if (!this.disabledSubmitButton) {
        // orgInfo may have been saved after this page initialised.
        this.getSessionOrg();
        const newValues = this.setNewValues();
        sessionStorage.setItem('ngStorage-savedData', JSON.stringify(this.getStorageSafeSavedData(newValues)));
        this.fname = this.firstName.value.trim();
        this.lname = this.lastName.value.trim();
        const user_id = this.findUserId();
        const request = {
          'userid': user_id,
          'company_id': environment.companyId,
          'verification_attributes': [
            {
              'attribute_name': 'sn',
              'attribute_value': this.lastName.value.trim()
            }
          ],
          'notification_value': '',
          'notification_method': 'list',
          'notification_flow': 'actv'
        };

        this.errorService.showError.next(false);
        window.scrollTo(0, 0);
        this.showLoading = true;
        this.hideSessionTimeout.emit(true);
        console.log("customer-information-form-utf - submit: calling Verify Identity");
        this.cfetService.cfetLivePost(request, CFETILMEndpointsConstant.VERIFY_IDENTITY_ACTIVATION).subscribe((data) => {
          console.log("customer-information-form-utf - submit: calling verifyIdentityActivationSuccess");
          this.verifyIdentityActivationSuccess(data, newValues);
        }, (error) => {
          console.log("customer-information-form-utf - submit: calling verifyIdentityActivationFailed");
          this.verifyIdentityActivationFailed(error, newValues);
        });
      }
    }
  }

  getCIDValue(data) {
    if (data) {
      const index = data.indexOf("c_id");
      const cIdValue = data[index + 1];
      return cIdValue;
    }
    return "N";
  }

  getStorageSafeSavedData(values) {
    const sanitizedValues = { ...(values || {}) };
    delete sanitizedValues.ctn;
    delete sanitizedValues.dob;
    return sanitizedValues;
  }

  verifyIdentityActivationSuccess(data, newValues) {
    const errorCode =
      data?.error?.errorcode ||
      data?.errorcode ||
      data?.error?.errorCode;

    if (Number(errorCode) === 1033) {
      if (data.error.variables && this.getCIDValue(data.variables) == "Y") {
        this.showLoading = false;
        this.attCustomerExists = true;
        this.errorMessage = CfetErrorMessagesConstant.CFET_ERROR_1033_USER_ID_EXISTS;
        this.errorService.displayErrorInfoMessage(this.errorMessage, this.errorReturnLink, false);
      }
      else if (this.affiliationCode && this.codeOrgDetails && !this.codeOrgDetails['isSpaOrg']) {
        this.tempverificationStatus = 'NotRequired';
        this.getOrgByAffillationCode();
      } else {
        this.sheeridServicecall(newValues);
      }
    } else if (data && data.error && data.error.errorcode ||
      (data && data.status === 'Success' && data.available_notification_methods !== undefined) || (data && data.errorcode === 1047)) {
      console.log("customer-information-form-utf - verifyIdentityActivationSuccess: success, errorcode == 1047");
      this.showLoading = false;
      this.emailAlreadyExists = true;
      this.hideSessionTimeout.emit(false);
      const messageArray = [];
      messageArray.push(CfetErrorMessagesConstant.CFET_ERROR_1097, CfetErrorMessagesConstant.CFET_eligibility_existing_user);
      this.errorService.displayErrorMessageList(messageArray);
      if (this.userID === '' || this.userID === undefined) {
        this.inputEmail.nativeElement.focus();
      }
    }
    console.log("customer-information-form-utf - verifyIdentityActivationSuccess: end");
  }

  verifyIdentityActivationFailed(error, newValues) {
    var loggedInUser = false;
    const loggedInUserInfo = JSON.parse(sessionStorage.getItem('AMUTFHeaders'));
    if (loggedInUserInfo && loggedInUserInfo.userid) {
      loggedInUser = true;
    }
    if (error?.error?.errorcode === 1033) {
      if (!loggedInUser && error.error.variables && this.getCIDValue(error.error.variables) === "Y") {
        this.showLoading = false;
        this.attCustomerExists = true;
        this.errorMessage = CfetErrorMessagesConstant.CFET_ERROR_1033_USER_ID_EXISTS;
        this.errorService.displayErrorInfoMessage(this.errorMessage, this.errorReturnLink, false);
      }
      else if (this.affiliationCode && this.codeOrgDetails && !this.codeOrgDetails['isSpaOrg']) {
        this.tempverificationStatus = 'NotRequired';
        this.getOrgByAffillationCode();
      } else {
        this.sheeridServicecall(newValues);
      }
    } else if (error?.error?.errorcode && (error.error.errorcode === 1019 || error.error.errorcode === 1016 || error.error.errorcode === 1047)) {
      this.showLoading = false;
      this.emailAlreadyExists = true;
      this.hideSessionTimeout.emit(false);
      const messageArray = [];
      messageArray.push(CfetErrorMessagesConstant.CFET_ERROR_1097, CfetErrorMessagesConstant.CFET_eligibility_existing_user);
      this.errorService.displayErrorMessageList(messageArray);
      if (this.userID === '' || this.userID === undefined) {
        this.inputEmail.nativeElement.focus();
      }
    }
  }

  navLogin() {
    this.router.navigate([CfetPageNamesConstant.UTF_REGISTRATION]);
  }

  getOrgByAffillationCode() {
    this.organizationInfo = {};
    this.showLoading = true;
    if (!this.codeOrgDetails || !this.codeOrgDetails['orgid'] || !this.codeOrgDetails['orgProfileInfo']) {
      // Ret-code/RapidSOS org details missing - stop the spinner instead of hanging/crashing.
      this.handleOrgSearchError();
      return;
    }
    this.orgIdSelected = this.codeOrgDetails['orgid'];
    this.createOrganizationsData(this.codeOrgDetails['orgProfileInfo'], this.codeOrgDetails['orgid']);
  }

  getProgramID() {
    if (this.type && this.type === 'Military') {
      this.programId = environment.miltaryProgramid;
    } else if (this.type && this.type === 'Medical') {
      this.programId = environment.medicalProgramid;
    } else if (this.type && this.type === 'Employee') {
      this.programId = environment.employeeProgramid;
    } else {
      this.programId = environment.responderProgramid;
    }
  }

  addResidential() {
    this.residentialAdd = this.address2Value.value !== '' ? this.address1Value.value + ',' + this.address2Value.value : this.address1Value.value;
  }

  setEntityStatus(entityStatus: any): any {
    let entStatus;
    entityStatus.forEach(val => {
      if (val.status && val.status !== undefined) {
        if (Array.isArray(val.status)) {
          entStatus = val.status.join(',');
        } else {
          entStatus = val.status;
        }
      }
    });
    console.log("Final status sent:", entStatus);
    return entStatus;
  }

  onReadyStateChangeIfTypeIsEmployee(xhr, data, companyInfo, newValues1, entStatus) {
    let empVerRequestParam: any;
    let empVerificationId: any;
    xhr.onreadystatechange = function () {
      if (xhr.response && xhr.readyState === 4 && xhr.status === 200) {
        data = JSON.parse(xhr.response);
        empVerificationId = data.verificationId;
        const resturl2 = CFETILMEndpointsConstant.SHEER_ID_VERIFICATION_URL + '/' + empVerificationId +
          CFETILMEndpointsConstant.SHEER_ID_EMP_VER_URL;
        const xhrEmp = new XMLHttpRequest();
        empVerRequestParam = {
          'firstName': this.firstName.value.trim(),
          'lastName': this.lastName.value.trim(),
          'email': this.emailAddress.value && this.emailAddress.value !== '' ? this.emailAddress.value : this.userID,
          'phoneNumber': this.mobilenumber.value,
          'address1': this.residentialAdd,
          'city': this.cityValue.value,
          'state': this.stateValue.value,
          'postalCode': this.zipCode.value,
          'metadata': {
            'phoneNumber': this.mobilenumber.value,
            'agencyAddress': companyInfo.selectedAddress,
            'agencyState': (companyInfo?.selectedStateInWorkplace || companyInfo?.state || '').split(':')[0],
            'agencyZipCode': companyInfo.selectedZipInWorkplace,
            'agencyCity': companyInfo.selectedCity,
            'middleName': this.middleName.value,
            'workEmail': this.workEmailAddress.value,
            'workidnumber': this.workidnumber.value,
            'employeeType': this.selectedEmpVolButton,
            'federalEmployee': this.selectedfedEmployee,
            'responderType': this.entity,
            'jobFunction': this.jobfunction,
            'subAccountID': companyInfo.orgid,
            'locationID': companyInfo.locationID ? companyInfo.locationID : '0',
            'verifyType': 'verify'
          }
        };
        let orgobject = {};
        const selectedCategory = sessionStorage.getItem('selectedCategory');
        orgobject = {
          'id': 0,
          'name': companyInfo.selectedName && companyInfo.selectedName.trim() !== '' ? companyInfo.selectedName : selectedCategory
        };
        empVerRequestParam.organization = orgobject;
        empVerRequestParam = JSON.stringify(empVerRequestParam);
        newValues1['entityStatus'] = entStatus;
        sessionStorage.setItem('ngStorage-savedData', JSON.stringify(newValues1));
        xhrEmp.open('POST', resturl2);
        xhrEmp.setRequestHeader('Content-Type', 'application/json');
        xhrEmp.send(empVerRequestParam);
        this.onReadyStateChange(xhrEmp);
      }
    }.bind(this);
  }

  onReadyStateChange(xhrEmp: any) {
    xhrEmp.onreadystatechange = function () {
      if (xhrEmp.response && xhrEmp.readyState === 4 && xhrEmp.status === 200) {
        const collectEmpVerData = JSON.parse(xhrEmp.response);
        if (collectEmpVerData.currentStep.toLowerCase() !== 'error') {
          const setCurrentStep = {
            'currentStep': collectEmpVerData.currentStep,
            'submissionUrl': collectEmpVerData.submissionUrl,
            'verificationId': collectEmpVerData.verificationId
          };
          sessionStorage.setItem('ngStorage-currentStepData', JSON.stringify(setCurrentStep));
          this.tempverificationStatus = setCurrentStep.currentStep;
          if ((this.affiliationCode || this.isRapidSosOrg) && this.codeOrgDetails && this.codeOrgDetails['isSpaOrg']) {
            this.getOrgByAffillationCode();
          } else {
            this.getOrgByJobFunction();
          }
        } else {
          this.showLoading = false;
          this.errorMessage = collectEmpVerData.systemErrorMessage;
          this.errorService.displayErrorMessage(this.errorMessage);
          window.scrollTo(0, 0);
        }
      }
    }.bind(this, xhrEmp);
  }

  setsheerIdorgName(entity, companyInfo) {
    let sheerIdorgName: any;
    if (this.type === 'Military') {
      sheerIdorgName = entity !== 'Military First Responder' ? entity : 'Army';
    } else {
      sheerIdorgName = companyInfo?.selectedName || companyInfo?.organizationName || companyInfo?.name || entity;
    }
    console.log("FINAL ORG NAME:", sheerIdorgName);
    return sheerIdorgName;
  }

  onReadyStateChangeIfTypeIsNotEmployee(xhr, data, resturl2, companyInfo, entStatus, newValues1) {
    xhr.onreadystatechange = function () {
      if (xhr.response && xhr.readyState === 4 && xhr.status === 200) {
        data = JSON.parse(xhr.response);
        // To check if there is any errors occured
        if (data && data.errorIds && data.errorIds.length === 0) {
          let collectData: any;
          // Get Org Id Info
          const xhr1 = new XMLHttpRequest();
          xhr1.open('GET', resturl2);
          xhr1.send();
          this.onReadyStateChangeForRestUrl2(xhr, xhr1, data, collectData, companyInfo, entStatus, newValues1);
        }
      }
    }.bind(this, xhr);
  }

  onReadyStateChangeForRestUrl2(xhr, xhr1, data, collectData, companyInfo, entStatus, newValues1) {
    xhr1.onreadystatechange = function () {
      if (xhr1.response && xhr1.readyState === 4 && xhr1.status === 200) {
        const data1 = JSON.parse(xhr1.response);
        const verificationfn = function () {
          this.returnVerificationFunction(data1, collectData, companyInfo, this.type, entStatus, newValues1);
        }.bind(this);

        if (this.type === 'Military') {
          const collectStatusURL = data.submissionUrl;
          const collectStatusxhr = new XMLHttpRequest();
          const statusTokens = this.flattenStatusTokens(this.status);
          const mappedMilitaryStatus = this.mapStatus(statusTokens[0], 'Military');
          const statusrequestParam = JSON.stringify({
            status: mappedMilitaryStatus
          });
          newValues1['entityStatus'] = entStatus;
          sessionStorage.setItem('ngStorage-savedData', JSON.stringify(newValues1));
          collectStatusxhr.open('POST', collectStatusURL);
          collectStatusxhr.setRequestHeader('Content-Type', 'application/json');
          collectStatusxhr.send(statusrequestParam);
          collectStatusxhr.onreadystatechange = function () {
            if (collectStatusxhr.response && collectStatusxhr.readyState === 4 && collectStatusxhr.status === 200) {
              //collect milirtary personal info
              collectData = JSON.parse(collectStatusxhr.response);
              verificationfn();
            }
          };
        } else {
          collectData = JSON.parse(xhr.response);
          verificationfn();
        }
      }
    }.bind(this, xhr1);
  }
  returnVerificationFunction(data1, collectData, companyInfo, type, entStatus, newValues1) {
    const verificationURL = collectData.submissionUrl;
    this.sheerIdCurrentStepVerificationUrl = verificationURL;
    const verificationxhr = new XMLHttpRequest();
    const normalizedType = this.normalizeType(type);

    let verrequestParam: any = {
      firstName: this.firstName.value.trim(),
      lastName: this.lastName.value.trim(),
      email: this.emailAddress.value && this.emailAddress.value !== '' ? this.emailAddress.value : this.userID,
      phoneNumber: this.mobilenumber.value,
      metadata: {
        phoneNumber: this.mobilenumber.value,
        agencyAddress: companyInfo?.selectedAddress || '',
        agencyState: (companyInfo?.selectedStateInWorkplace || companyInfo?.state || '').split(':')[0],
        agencyZipCode: companyInfo?.selectedZipInWorkplace || '',
        agencyCity: companyInfo?.selectedCity || '',
        middleName: this.middleName.value,
        workEmail: this.workEmailAddress.value,
        workidnumber: this.workidnumber.value,
        employeeType: this.selectedEmpVolButton,
        federalEmployee: this.selectedfedEmployee,
        responderType: this.entity,
        jobFunction: this.jobfunction,
        subAccountID: companyInfo?.orgid,
        locationID: companyInfo?.locationID ? companyInfo.locationID : '0',
        verifyType: 'verify'
      }
    };
    const dob = this.dateOfBirth.value;
    const [mm, dd, yyyy] = dob.split('/');
    verrequestParam.birthDate = `${yyyy}-${mm}-${dd}`;
    const eligibilityInfo = JSON.parse(
      sessionStorage.getItem('eligibilityInfo') || '{}'
    );
    const selectedCategory = sessionStorage.getItem('selectedCategory');
    let orgobject = {};
    if (normalizedType === 'Military') {
      orgobject = {
        id: data1?.[0]?.id || 0,
        name: data1?.[0]?.name ||
          companyInfo?.selectedName ||
          companyInfo?.organizationName ||
          companyInfo?.name ||
          eligibilityInfo?.entity ||
          selectedCategory ||
          this.entity ||
          ''
      };
    }
    else if (normalizedType === 'Employee') {
      const orgFromSheer = data1?.[0];
      orgobject = {
        id: orgFromSheer?.id || 0,
        name:
          orgFromSheer?.name ||
          companyInfo?.selectedName ||
          companyInfo?.organizationName ||
          selectedCategory ||
          eligibilityInfo?.entity ||
          this.entity
      };
    }
    else {
      orgobject = {
        id: 0,
        name: companyInfo?.selectedName || eligibilityInfo?.entity || companyInfo?.organizationName || companyInfo?.name || selectedCategory || this.entity
      };
    }
    verrequestParam.organization = orgobject;
    const postalCodeFNR =
      companyInfo?.selectedZipInWorkplace ||
      companyInfo?.zip ||
      companyInfo?.postalCode ||
      sessionStorage.getItem('zipCode') ||
      JSON.parse(sessionStorage.getItem('ngStorage-savedData') || '{}')?.zipCode ||
      '';
    if (normalizedType !== 'Military' && postalCodeFNR) {
      verrequestParam.metadata['agencyZipCode'] = postalCodeFNR;
      verrequestParam.metadata['postalCode'] = postalCodeFNR;
      verrequestParam['postalCode'] = postalCodeFNR;
    }
    let rawStatusArray: string[] = [];
    if (Array.isArray(entStatus)) {
      rawStatusArray = entStatus;
    } else if (typeof entStatus === 'string') {
      rawStatusArray = entStatus.split(',');
    }
    rawStatusArray = rawStatusArray
    const tempArray: string[] = [];
    rawStatusArray.forEach(s => {
      if (s) {
        const parts = s.split(',');
        parts.forEach(p => {
          const val = p.toString().trim().toUpperCase();
          if (val) tempArray.push(val);
        });
      }
    });

    rawStatusArray = tempArray;
    const mappedStatuses = rawStatusArray
      .map(s => this.mapStatus(s, normalizedType))
      .filter(s => s);
    if (normalizedType === 'Employee') {
      verrequestParam.statuses = mappedStatuses[0] || 'EMPLOYEE';
    }
    else if (normalizedType === 'Medical') {
      verrequestParam.statuses = mappedStatuses.length
        ? mappedStatuses
        : ['NURSE'];
    }
    else {
      verrequestParam.statuses = mappedStatuses.length ? mappedStatuses : ['EMT'];
    }
    newValues1['entityStatus'] = mappedStatuses;
    sessionStorage.setItem('ngStorage-savedData', JSON.stringify(this.getStorageSafeSavedData(newValues1)));
    console.log("FINAL PAYLOAD:", verrequestParam);
    verrequestParam = JSON.stringify(verrequestParam);
    verificationxhr.open('POST', verificationURL);
    verificationxhr.setRequestHeader('Content-Type', 'application/json');
    verificationxhr.send(verrequestParam);
    this.verificationxhrStateChange(verificationxhr);
  }
  normalizeType(type: string): string {
    if (!type) return '';
    const t = type.toLowerCase();
    if (t.includes('employee')) return 'Employee';
    if (t.includes('military')) return 'Military';
    if (t.includes('medical')) return 'Medical';
    if (t.includes('responder')) return 'FirstResponder';
    return 'Other';
  }
  // Splits any comma-joined entries (from malformed job config arrays) into clean individual tokens.
  flattenStatusTokens(status: any): string[] {
    const raw = Array.isArray(status) ? status : (status ? [status] : []);
    const tokens: string[] = [];
    raw.forEach(item => {
      if (typeof item === 'string') {
        item.split(',').forEach(token => {
          const trimmed = token.trim();
          if (trimmed) tokens.push(trimmed);
        });
      }
    });
    return tokens;
  }
  mapStatus(status: string, normalizedType: string): any {
    if (!status) return '';
    let s = status.toUpperCase();
    s = s.replace(/[^A-Z_]/g, '');
    if (normalizedType === 'Employee') {
      return 'EMPLOYEE';
    }
    if (normalizedType === 'Military') {
      if (s.includes('ACTIVE')) return 'ACTIVE_DUTY';
      if (s.includes('RESERVE')) return 'RESERVIST';
      return 'ACTIVE_DUTY';
    }
    if (normalizedType === 'Medical') {
      return s;   // ✅ KEEP DOCTOR / NURSE
    }
    if (normalizedType === 'FirstResponder') {
      if (s.includes('FIRE')) return 'FIREFIGHTER';
      if (s.includes('POLICE')) return 'POLICE';
      return 'EMT';
    }

    return s;
  }
  verificationxhrStateChange(verificationxhr) {
    verificationxhr.onreadystatechange = function () {
      if (verificationxhr.response && verificationxhr.readyState === 4 && verificationxhr.status === 200) {
        const verifieddata = JSON.parse(verificationxhr.response);
        if (verifieddata.currentStep.toLowerCase() !== 'error') {
          const setCurrentStep = {
            'currentStep': verifieddata.currentStep,
            'submissionUrl': verifieddata.submissionUrl,
            'verificationId': verifieddata.verificationId
          };
          sessionStorage.setItem('ngStorage-currentStepData', JSON.stringify(setCurrentStep));
          this.tempverificationStatus = setCurrentStep.currentStep;
          if ((this.affiliationCode || this.isRapidSosOrg) && this.codeOrgDetails && this.codeOrgDetails['isSpaOrg']) {
            this.getOrgByAffillationCode();
          } else {
            this.getOrgByJobFunction();
          }
        } else {
          this.showLoading = false;
          this.errorMessage = verifieddata.systemErrorMessage;
          this.errorService.displayErrorMessage(this.errorMessage);
          window.scrollTo(0, 0);
        }
      }
    }.bind(this, verificationxhr);
  }

  sheeridServicecall(newValues) {
    const newValues1 = newValues;
    sessionStorage.setItem('ngStorage-savedData', JSON.stringify(this.getStorageSafeSavedData(newValues1)));
    const restURL = CFETILMEndpointsConstant.SHEER_ID_VERIFICATION_URL;
    this.getProgramID();

    // Form the requestparam based on the programid
    const requestParam = JSON.stringify({
      programId: this.programId
    });
    // Initiate http request
    const xhr = new XMLHttpRequest();
    // xmlHttpRequest initiate POST request
    xhr.open('POST', restURL);
    // set request header for post call
    xhr.setRequestHeader('Content-Type', 'application/json');
    // send the requestparam
    xhr.send(requestParam);
    let data: any;
    let companyInfo: any;
    const entityStatus = [{ status: Array.isArray(this.status) ? this.status[0] : this.status }];
    const programId = this.programId;
    let sheerIdorgName = '';
    companyInfo = this.geteligibilityInfo.eligibilityStatus;
    console.log("companyInfo data:", companyInfo);
    this.addResidential();
    this.showLoading = true;
    let entStatus = this.setEntityStatus(entityStatus);

    if (this.type === 'Employee' && this.status === 'EMPLOYEE') {
      this.onReadyStateChangeIfTypeIsEmployee(xhr, data, companyInfo, newValues1, entStatus);
    } else {
      // Air National Guard, Army National Guard, Military First Responder- type: Military
      sheerIdorgName = this.setsheerIdorgName(this.entity, companyInfo);
      const params = {
        programId: programId,
        sheerIdorgName: sheerIdorgName
      };
      const resturl2 = `${this.urlUtil.formatURlParams(CFETILMEndpointsConstant.SHEER_ID_ORG_VER_URL, params)}`;
      // on response of the xhr
      this.onReadyStateChangeIfTypeIsNotEmployee(xhr, data, resturl2, companyInfo, entStatus, newValues1);
    }
  }

  createOrganizationsData(orgInfo, userRoleType) {
    this.organizationInfo[userRoleType] = {};
    this.organizationInfo[userRoleType].orgid = orgInfo.orgid;
    this.organizationInfo[userRoleType].orgName = orgInfo.orgName;
    if ((this.affiliationCode !== '' && this.affiliationCode !== undefined) || this.isRapidSosOrg) {
      this.setOrgProfileData(orgInfo, userRoleType);
    } else {
      this.setOrgProfileData(orgInfo.profile, userRoleType);
    }
  }

  setOrgProfileData(profile, userRoleType) {
    if (!this.organizationInfo[userRoleType].retailInfo) {
      this.organizationInfo[userRoleType].retailInfo = {};
    }
    if ((this.affiliationCode !== '' && this.affiliationCode !== undefined) || this.isRapidSosOrg) {
      this.setFanNumber(profile, userRoleType);
      this.addUser();
    } else {
      if (!Array.isArray(profile)) {
        // Org profile missing/malformed - stop the spinner instead of throwing and hanging.
        this.handleOrgSearchError();
        return;
      }
      profile.forEach(val => {
        this.organizationInfo[userRoleType].retailInfo[val.attribute_name] = val.attribute_value !== undefined ? val.attribute_value : val.attribute_mvalue;
        if (val.attribute_name === 'FAN_LIST') {
          if (!this.organizationInfo[userRoleType].retailFanAccountList) {
            this.organizationInfo[userRoleType].retailFanAccountList = {};
          }
          val.attribute_mvalue.forEach(val2 => {
            this.organizationInfo[userRoleType].fanName = val2;
            this.organizationInfo[userRoleType].retailFanAccountList['fanName'] = val2;
          });
        }
      });
      this.addUser();
    }
  }

  setFanNumber(profile, userRoleType) {
    // RapidSOS orgs have no retCode to match, so use the FAN resolved during eligibility.
    const preResolvedFan = this.codeOrgDetails && this.codeOrgDetails['fanName'];
    if (preResolvedFan) {
      if (!this.organizationInfo[userRoleType].retailFanAccountList) {
        this.organizationInfo[userRoleType].retailFanAccountList = {};
      }
      this.organizationInfo[userRoleType].fanName = preResolvedFan;
      this.organizationInfo[userRoleType].retailFanAccountList['fanName'] = preResolvedFan;
      return;
    }
    // GET_AFFILIATION_CODE returns "fan" (lowercase); GET_ORG_PROFILE returns "FAN" (uppercase) - check both.
    const fanList = profile.fan || profile.FAN;
    if (fanList && fanList.length > 0) {
      if (!this.organizationInfo[userRoleType].retailFanAccountList) {
        this.organizationInfo[userRoleType].retailFanAccountList = {};
      }
      fanList.forEach(val2 => {
        if (val2?.retCode && this.affiliationCode &&
          val2.retCode.toLowerCase() === this.affiliationCode.toLowerCase()) {
          this.organizationInfo[userRoleType].fanName = val2.fan;
          this.organizationInfo[userRoleType].retailFanAccountList['fanName'] = val2.fan;
        }
      });
    }
  }
  filterAlphaNumeric(event: any) {
    const input = event.target;
    const value = input.value;
    input.value = value.replace(/[^A-Za-z0-9._%+-]/g, '').replace(/@/g, '');
  }

  addUser() {
    console.log("customer-information-form-utf - addUser: start");
    if (((this.emailAddress && this.emailAddress.value !== '') || (this.userID && this.userID !== ''))
      && this.lastName && this.lastName.value.trim() !== '') {
      const request = {
        'userid': this.emailAddress.value ? this.emailAddress.value.trim() : this.userID.trim(),
        'company_id': environment.companyId,
        'verification_attributes':
          [
            {
              'attribute_name': 'sn',
              'attribute_value': this.lastName.value.trim()
            }
          ],
        'notification_value': '',
        'notification_method': 'list',
        'notification_flow': 'actv'
      };
      console.log("customer-information-form-utf - call Verify Identity");
      this.cfetService.cfetLivePost(request, CFETILMEndpointsConstant.VERIFY_IDENTITY_ACTIVATION).subscribe((data) => {
        console.log("customer-information-form-utf - addUser: returned data = " + data);
        this.postCallBasedOnData(data);
      }, (error) => {
        if (error?.error?.errorcode === 1033) {
          this.cfetLivePostDataError1033(error);
        } else if (error?.error?.errorcode && (error.error.errorcode === 1019 || error.error.errorcode === 1016 || error.error.errorcode === 1047)) {
          this.cfetLivePostDataError1047();
        } else {
          // Unrecognized error - stop the spinner instead of hanging forever.
          this.handleOrgSearchError();
        }
      });
    } else {
      // Required fields missing so the verify-identity call is never sent - stop the spinner instead of hanging forever.
      this.handleOrgSearchError();
    }
  }

  postCallBasedOnData(data) {
    console.log("customer-information-form-utf - postCallBasedOnData: start");
    if (data && data.error && data.error.errorcode && data.error.errorcode === 1033) {
      this.cfetLivePostDataError1033(data);
    } else if (data && data.error && data.error.errorcode ||
      (data && data.status === 'Success' && data.available_notification_methods !== undefined) || (data && data.errorcode === 1047)) {
      this.cfetLivePostDataError1047();
    }
  }

  cfetLivePostDataError1033(dataError: any) {
    let uaactvidx;
    dataError.error.variables.forEach((element, uaactvindx) => {
      if (element === 'ua_actv') {
        uaactvidx = uaactvindx;
      }
    });
    const ua_actv = dataError.error.variables[uaactvidx + 1];
    this.addUserBasedonOrg(ua_actv, this.orgIdSelected);
  }

  cfetLivePostDataError1047() {
    this.showLoading = false;
    this.emailAlreadyExists = true;
    this.hideSessionTimeout.emit(false);
    const messageArray = [];
    messageArray.push(CfetErrorMessagesConstant.CFET_ERROR_1097, CfetErrorMessagesConstant.CFET_eligibility_existing_user);
    this.errorService.displayErrorMessageList(messageArray);
    if (this.userID === '' || this.userID === undefined) {
      this.inputEmail.nativeElement.focus();
    }
  }

  addToken(addToken) {
    return (this.emailAddress.value && this.emailAddress.value !== '') ? addToken.concat(this.emailAddress.value) : addToken.concat(this.userID);
  }

  returnIfEmployeeIsSelectedFed() {
    return (this.selectedfedEmployee === 'Yes') ? true : false;
  }

  returnUserId() {
    return (this.emailAddress.value && this.emailAddress.value !== '') ? this.emailAddress.value : this.userID;
  }
  domainsList() {
    const params = {
      companyId: environment.companyId,
      xorgid: this.codeOrgDetails ? this.codeOrgDetails['orgid'] : undefined
    };
    // If already cached, reuse the cached domain list
    if (params.xorgid && this.approvedDomainsCache[params.xorgid]) {
      this.domainList = this.approvedDomainsCache[params.xorgid];
      this.domainValueOption = { value: 'Select a domain', text: 'Select a domain' };
      return;
    }

    if (params.xorgid) {
      const url = `${this.urlUtil.formatURlParams(CFETILMEndpointsConstant.GET_ORG_PROFILE, params)}`;
      this.showLoading = true;
      this.cfetService.cfetLiveGet('', url).subscribe((data: any) => {
        this.showLoading = false;
        this.errorService.hideError();

        const profileInfo = data.profile;
        const domains: Array<{ value: string; text: string }> = [];
        if (profileInfo && Array.isArray(profileInfo)) {
          profileInfo.forEach((element: any) => {
            if (element.attribute_name === 'approvedDomains' && element.attribute_mvalue) {
              element.attribute_mvalue.forEach((item: any) => {
                domains.push({ value: item.toString(), text: item.toString() });
              });
            }
            if (element.attribute_name === 'EVSP') {
              this.isWorkEmailMandatory = true;
            }
          });
        }

        this.domainList = domains;
        this.domainValueOption = { value: 'Select a domain', text: 'Select a domain' };

        // Cache domains for this orgid
        this.approvedDomainsCache[params.xorgid] = domains;
      }, (error) => {
        this.showLoading = false;
        this.errorService.showError.next(true);
        console.error('Error fetching domain list', error);
      });
    }
  }

  setRequestParam(requestParam) {
    if (this.accessMitigation) {
      this.linkcuser = 'linkF';
      //N-E : unAuthenticated flow.
    } else if (this.attEmail) {
      // New/Existing scenario : Existing Consumer user but New FN
      requestParam.profile.push({
        'attribute_name': 'c_id',
        'attribute_value': this.attEmail
      });
      if (this.attEmail === this.userID) {
        this.linkcuser = 'linkC';
      } else {
        this.linkcuser = 'linkF';
        sessionStorage.setItem('c_ID', this.attEmail);
        sessionStorage.setItem('separateId', 'true');
      }
    } else if (this.premierTerritories.includes(this.stateValue.value)) {
      this.linkcuser = '';
    } else {
      this.linkcuser = 'linkF';
    }
    return requestParam;
  }

  isDomainListEmpty(): boolean {
    return !this.domainList || this.domainList.length === 0;
  }

  isWorkEmailOptional(): boolean {
    if (!this.affiliationCode) {
      return true;
    }
    return this.checkOraRequiredAttribute('agencyEmail') && this.isDomainListEmpty();
  }

  addUserBasedonOrg(addToken, userRoleType) {
    this.retailFanAccountList = [];
    this.organizationid = this.organizationInfo[userRoleType].orgid;
    this.organisationName = this.organizationInfo[userRoleType].orgName;
    this.fanName = this.organizationInfo[userRoleType].fanName;
    this.retailFanAccountList['fanName'] = this.organizationInfo[userRoleType].retailFanAccountList['fanName'];
    this.selectedValue.fan = this.organizationInfo[userRoleType].fanName;
    this.userid = this.addToken(addToken);
    let requestParam: any;
    let isFederal = this.returnIfEmployeeIsSelectedFed();
    sessionStorage.setItem('agencyEmail', this.workEmailAddress.value.trim() + '@' + this.domainValue.value.trim());
    requestParam = {
      'userid': this.userid,
      'company_id': environment.companyId,
      'self_add': true,
      'profile': [
        {
          'attribute_name': 'cn',
          'attribute_value': this.firstName.value.trim()
        },
        {
          'attribute_name': 'sn',
          'attribute_value': this.lastName.value.trim()
        },
        {
          'attribute_name': 'Org_Name',
          'attribute_mvalue': [this.organisationName]
        },
        {
          'attribute_name': 'OrgID',
          'attribute_mvalue': [this.organizationid]
        },
        {
          'attribute_name': 'FAN',
          'attribute_mvalue': [
            this.selectedValue.fan
          ]
        },
        {
          'attribute_name': 'contactEmail',
          'attribute_value': this.returnUserId()
        }, {
          'attribute_name': 'contactCTN',
          'attribute_value': this.mobilenumber.value.replace(/-/g, '')
        }, {
          'attribute_name': 'contactCTNisFN',
          'attribute_value': 'FALSE'
        }, {
          'attribute_name': 'zipcode',
          'attribute_value': this.zipCode.value
        }, {
          'attribute_name': 'city',
          'attribute_value': this.cityValue.value
        }, {
          'attribute_name': 'state',
          'attribute_value': this.stateValue.value
        }, {
          'attribute_name': 'Address 1',
          'attribute_value': this.address1Value.value
        }, {
          'attribute_name': 'Address 2',
          'attribute_value': this.address2Value.value
        }, {
          'attribute_name': 'firstResponderType',
          'attribute_value': this.entity
        }, {
          'attribute_name': 'employeeType',
          'attribute_value': this.selectedEmpVolButton
        }, {
          'attribute_name': 'dateOfBirth',
          'attribute_value': this.dateOfBirth.value.split('/')[2] + '-' +
            this.dateOfBirth.value.split('/')[0] + '-' + this.dateOfBirth.value.split('/')[1]
        },
        {
          'attribute_name': 'employeeId',
          'attribute_value': this.workidnumber.value
        }, {
          'attribute_name': 'firstResponderTypeClass',
          'attribute_value': this.jobfunction
        }, {
          'attribute_name': 'federal',
          'attribute_value': isFederal
        }, {
          'attribute_name': 'firstResponderConfirmation',
          'attribute_value': '1'
        }, {
          'attribute_name': 'user_type',
          'attribute_value': this.userType
        }, {
          'attribute_name': 'subType',
          'attribute_value': this.subType
        }, {
          'attribute_name': 'pilot_user',
          'attribute_value': environment.pilot.toString()
        }
      ],
      'entitlement': [
        {
          'attribute_name': 'G_FN'
        },
        {
          'attribute_name': 'G_FN_VOL'
        }
      ]
    };
    requestParam = this.setRequestParam(requestParam);
    this.setSheerIdCurrentStep();
    if (this.sheeridCurrentStep && this.sheeridCurrentStep['verificationId']) {
      requestParam.profile.push({
        'attribute_name': 'verificationId',
        'attribute_value': this.sheeridCurrentStep['verificationId']
      });
      requestParam.profile.push({
        'attribute_name': 'verificationStatus',
        'attribute_value': this.sheeridCurrentStep['currentStep']
      });
    }
    if ((this.affiliationCode !== '' && this.affiliationCode !== undefined) || this.isRapidSosOrg) {
      requestParam.profile.push({
        'attribute_name': 'retCodeAssigned',
        // RapidSOS orgs have no ret-code, so send an empty value.
        'attribute_value': this.isRapidSosOrg ? '' : this.affiliationCode
      });
    }
    if (this.middleName.value !== '') {
      requestParam.profile.push({
        'attribute_name': 'mn',
        'attribute_value': this.middleName.value
      });
    }
    const agencyNameInfo = sessionStorage.getItem('agencyNameSource');
    switch (agencyNameInfo && agencyNameInfo.trim()) {
      case 'userManualEntry':
        this.agencyNameSource = 'User Entry';
        break;
      case 'userSearchResult':
        this.agencyNameSource = 'ILM DB';
        break;
      case 'fuzzyAI':
        this.agencyNameSource = 'AI Search';
        break;
      default:
        this.agencyNameSource = null;
        break;
    }
    if (this.agencyNameSource !== null) {
      requestParam.profile.push({
        'attribute_name': 'AgencyNameSource',
        'attribute_value': this.agencyNameSource
      });
      // 'agencyName' is added later by setAgencyNameIntoRequestParam() (via
      // setRequestParamAnother()), which reads the canonical selectedagencyInfo -
      // pushing it here too caused a duplicate 'agencyName' attribute in the payload.
    }
    if (this.affiliationCode) {
      if (this.domainValue.value && this.domainValue.value.trim() !== '') {
        const agencyEmail = this.workEmailAddress.value.trim() + '@' + this.domainValue.value.trim();
        requestParam.profile.push({
          'attribute_name': 'agencyEmail',
          'attribute_value': agencyEmail
        });
        sessionStorage.setItem('agencyEmail', agencyEmail);
        sessionStorage.setItem('hasDomainValue', 'true');
      } else {
        requestParam.profile.push({
          'attribute_name': 'agencyEmail',
          'attribute_value': this.workEmailAddress.value
        });
        sessionStorage.setItem('agencyEmail', this.workEmailAddress.value);
        sessionStorage.setItem('hasDomainValue', 'false');
      }
    } else {
      // This block will handle the case where there is no affiliationCode
      requestParam.profile.push({
        'attribute_name': 'agencyEmail',
        'attribute_value': this.workEmailAddress.value
      });
    }
    requestParam = this.setRequestParamAnother(requestParam);
    // The API rejects AgencyNameSource without agencyName.
    const hasAgencyName = requestParam.profile.some(attr => attr.attribute_name === 'agencyName');
    if (!hasAgencyName) {
      requestParam.profile = requestParam.profile.filter(attr => attr.attribute_name !== 'AgencyNameSource');
    }
    this.cfetService.cfetLivePost(requestParam, CFETILMEndpointsConstant.ADD_USER_V3).subscribe((data) => {
      if (data?.status?.toLowerCase() === 'success' && 
            this.sheeridCurrentStep?.currentStep === CFETILMSheerIdApiConstant.success) {
              if (this.sheeridCurrentStep) {
      const sheerIdApiPayload: SheerIdApiIntegrationPayload = {
        isActive: 'TRUE',
        company_user_id: data?.company_user_id,
        company_id: 21,
        userid: data?.user_id,
        completedDate: this.sheeridApiService.getCurrentETTime(),
        verification: {
          process: CFETILMSheerIdApiConstant.processName,
          phase: {
            name: CFETILMSheerIdApiConstant.instantVerification,
          },
          step: CFETILMSheerIdApiConstant.verificationSuccess,
          status: CFETILMSheerIdApiConstant.completed,
        },
        sheerId: {
          programId: this.programId,
          verificationId: this.sheeridCurrentStep?.verificationId,
          status: this.sheeridCurrentStep?.currentStep,
          successDate: this.sheeridApiService.getCurrentETTime(),
        },
        trigger: {
          source: CFETILMSheerIdApiConstant.source,
        },
      };
      this.sheeridApiService
        .sendSheerIdApiIntegrationData(sheerIdApiPayload)
        .subscribe(
          (response: any) => {
            console.log('SheerId API integration response----->:', response);
          },
          (error: any) => {
            console.error('SheerId API integration error------>:', error);
          },
        );
      }
    }
    if (this.sheeridCurrentStep?.currentStep === CFETILMSheerIdApiConstant.SheerIdDocUpload) {
      const sheerIdApiIntegrationData: SheerIdApiIntegrationPayload = {
        company_user_id: data?.company_user_id,
        company_id: 21,
        userid: data?.user_id,
        sheerId: {
          programId: this.programId,
          verificationId: this.sheeridCurrentStep?.verificationId,
        }
      }
      sessionStorage.removeItem('sheerIdApiIntegrationData');
      sessionStorage.setItem('sheerIdApiIntegrationData', JSON.stringify(sheerIdApiIntegrationData));
    }
    this.addUserV3Success(data);
    },
      (error) => {
        this.addUserV3Error(error);
      });
  }
  ensureAgencyName() {
    const source = sessionStorage.getItem('agencyNameSource');
    let name = sessionStorage.getItem('agencyName');
    console.log(' [Agency Debug] Initial Values');
    console.log('agencyNameSource:', source);
    console.log('agencyName:', name);
    if (source) {
      if (!name || name === 'undefined' || name.trim() === '') {
        console.log(' [Agency Debug] agencyName missing, trying to recover...');
        const orgRaw = sessionStorage.getItem('orgDetailInfo');
        console.log('orgDetailInfo (raw):', orgRaw);
        if (orgRaw && orgRaw !== 'undefined') {
          try {
            const org = JSON.parse(orgRaw);
            console.log('orgDetailInfo (parsed):', org);
            name =
              org?.org_name ||
              org?.selectedName ||
              org?.orgName ||
              '';
            console.log(' [Agency Debug] Extracted agencyName:', name);
            if (name) {
              sessionStorage.setItem('agencyName', name);
              console.log(' [Agency Debug] agencyName SET:', name);
            } else {
              console.log(' [Agency Debug] No valid agencyName found → removing source');
              sessionStorage.removeItem('agencyNameSource');
            }

          } catch (e) {
            console.error(' [Agency Debug] JSON parse failed:', e);
            sessionStorage.removeItem('agencyNameSource');
          }
        } else {
          console.log('[Agency Debug] orgDetailInfo missing → removing source');
          sessionStorage.removeItem('agencyNameSource');
        }
      } else {
        console.log(' [Agency Debug] agencyName already valid, no action needed');
      }
    } else {
      console.log(' [Agency Debug] No agencyNameSource found, skipping');
    }
    console.log('agencyNameSource:', sessionStorage.getItem('agencyNameSource'));
    console.log('agencyName:', sessionStorage.getItem('agencyName'));
  }
  addUserV3Error(error) {
    this.createUserSuccess = true;
    this.showLoading = false;
    this.hideSessionTimeout.emit(false);
    if (error?.error?.errorcode === 1082) {
      const errorsMessages = [this.cfetMessages.email_in_att, this.cfetMessages.email_att_already_used];
      this.errorService.displayErrorMessageList(errorsMessages);
      // Move the scroll bar to top
      window.scrollTo(0, 0);
    } else {
      this.errorMessage = error?.error?.message;
      this.errorService.displayErrorMessage(this.errorMessage);
      // Move the scroll bar to top
      window.scrollTo(0, 0);
    }
  }

  addUserV3Success(data) {
    if (data && data.status === 'success') {
      this.hideSessionTimeout.emit(false);
      this.createUserSuccess = true;
      sessionStorage.setItem('fnStatus', 'fnStatus=eligible-pending');
      this.displayVerificationMessage();
    } else if (data && data.errorcode) {
      this.showLoading = false;
      if (data.errorcode === 1007 || data.errorcode === 2008) {
        this.errorMessage = data.message;
        this.hideSessionTimeout.emit(false);
        this.errorService.displayErrorMessage(this.errorMessage);
        window.scrollTo(0, 0);
      }
    } else {
      if (data.message) {
        this.errorMessage = data.message;
        this.hideSessionTimeout.emit(false);
        this.showLoading = false;
        this.errorService.displayErrorMessage(this.errorMessage);
      }
      // Scroll bar to the top
      window.scrollTo(0, 0);
    }
  }


  setAgencyNameIntoRequestParam(requestParam) {
    if (this.selectedagencyInfo.selectedName) {
      requestParam.profile.push(
        {
          'attribute_name': 'agencyName',
          'attribute_value': this.selectedagencyInfo.selectedName
        });
    }
    return requestParam;
  }

  setRequestParamAnother(requestParam) {
    // agency name and address details; agencyNameSource means the user picked/entered a workplace.
    if ((this.affiliationCode && this.isSpaOrg) || (!this.affiliationCode) || this.agencyNameSource) {
      requestParam = this.setAgencyNameIntoRequestParam(requestParam);
      if (this.selectedagencyInfo.selectedCity && this.selectedagencyInfo.selectedCity !== '') {
        requestParam.profile.push(
          {
            'attribute_name': 'agencyCity',
            'attribute_value': this.selectedagencyInfo.selectedCity
          });
      }
      if (this.selectedagencyInfo.selectedStateInWorkplace && this.selectedagencyInfo.selectedStateInWorkplace !== '') {
        requestParam.profile.push(
          {
            'attribute_name': 'agencyState',
            'attribute_value': this.selectedagencyInfo.selectedStateInWorkplace
          });
      }
      if (this.selectedagencyInfo.selectedStateInWorkplace && this.selectedagencyInfo.selectedStateInWorkplace !== '') {
        requestParam.profile.push(
          {
            'attribute_name': 'agencyZipcode',
            'attribute_value': this.selectedagencyInfo.selectedZipInWorkplace
          });
      }
      if (this.selectedagencyInfo.selectedAddress) {
        requestParam.profile.push(
          {
            'attribute_name': 'agencyAddress',
            'attribute_value': this.selectedagencyInfo.selectedAddress
          });
      }
    }
    return requestParam;
  }

  setSheerIdCurrentStep() {
    if (sessionStorage.getItem('ngStorage-currentStepData') &&
      Object.keys(sessionStorage.getItem('ngStorage-currentStepData').length > 0)) {
      this.sheeridCurrentStep = JSON.parse(sessionStorage.getItem('ngStorage-currentStepData'));
    }
  }

  clearTimeout(event) {
    if (event) {
      this.clearSessionTimeout.emit(true);
    }
  }
  displayVerificationMessage() {
    this.showVerificationNotRequired = false;
    this.showPersonalInfoSection = false;
    this.showInstantVerificationSection = false;
    this.showVerificationPending = false;
    sessionStorage.setItem('linked_c_user', this.linkcuser);
    sessionStorage.setItem('userID', this.userID);
    sessionStorage.setItem('verificationStatus', this.tempverificationStatus);
    if (this.tempverificationStatus.toLowerCase() === 'notrequired') {
      this.showVerificationNotRequired = true;
      const orgobject = { 'orgname': this.organisationName };
      sessionStorage.setItem('orgName', JSON.stringify(orgobject));
    } else if (this.tempverificationStatus.toLowerCase() === 'success') {
      this.showInstantVerificationSection = true;
      this.progressTrackerEvent.emit('verified');
    } else {
      this.showVerificationPending = true;
      this.progressTrackerEvent.emit('verified');
    }
    this.showLoading = false;
    this.hideEditButton.emit(true);
    if (this.showInstantVerificationSection || this.showVerificationNotRequired) {
      this.goToInstantVerification.emit(true);
      this.progressTrackerEvent.emit('verified');
    }
  }

  getOrgByJobFunction() {
    const rapidSosReqParam = {
      "search_criteria": [{
        "attribute_name": "isSpaOrg",
        "attribute_value": "true"
      }, {
        "attribute_name": "isRapidSOS",
        "attribute_value": "true"
      }],
      "filter_attribute": "responder_sub_category"
    };
    // RapidSOS orgs aren't flagged in the isSpaOrg response, so fetch them separately and exclude by orgid.
    this.cfetService.cfetLivePost(rapidSosReqParam, CFETILMEndpointsConstant.SEARCH_DETAILS).subscribe(
      (rapidSosData: any) => this.fetchSpaOrgsExcludingRapidSos(this.collectOrgIds(rapidSosData)),
      (_error) => this.handleOrgSearchError());
  }

  fetchSpaOrgsExcludingRapidSos(rapidSosOrgIds: Set<string>) {
    const reqParam = {
      "search_criteria": [{
        "attribute_name": "isSpaOrg",
        "attribute_value": "true"
      }],
      "filter_attribute": "responder_sub_category"
    };
    this.cfetService.cfetLivePost(reqParam, CFETILMEndpointsConstant.SEARCH_DETAILS).subscribe((data: any) => {
      // Move the scroll bar to top
      window.scrollTo(0, 0);
      try {
      if (data) {
          const filteredData = data.filter(org => !rapidSosOrgIds.has(org.orgid));
          // Shared reference so the flag propagates across both loops (stop at first match).
          const search = { done: false };
          this.setProfileData(filteredData, search);
        if (this.orgIdSelected) {
          this.getRetailManagerRole();
          } else {
            // No org matched the customer's job function - stop the spinner instead of hanging forever.
            const noMatchMessage = CfetErrorMessagesConstant.CFET_NO_MATCHING_ORG_FOR_JOB_FUNCTION.replace('{jobfunction}', this.jobfunction);
            this.handleOrgSearchError(noMatchMessage);
          }
        } else {
          this.handleOrgSearchError();
        }
      } catch (e) {
        this.handleOrgSearchError();
      }
    },
      (_error) => this.handleOrgSearchError());
  }

  collectOrgIds(data: any): Set<string> {
    const orgIds = new Set<string>();
    if (Array.isArray(data)) {
      data.forEach(org => {
        if (org?.orgid) {
          orgIds.add(org.orgid);
        }
      });
    }
    return orgIds;
  }

  handleOrgSearchError(message?: string) {
        this.showLoading = false;
    this.errorMessage = message || this.cfetMessages.official_doc_system_error;
        this.errorService.displayErrorMessage(this.errorMessage);
        window.scrollTo(0, 0);
  }

  setProfileData(data, search) {
    data.forEach(val1 => {
      if (val1.profile && !search.done) {
        this.respondertypes = [];
        this.profileData = val1.profile;
        this.setResponderTypes(search, val1);
      }
    });
  }

  setResponderTypes(search, val1) {
    this.profileData.forEach(val2 => {
      if (!search.done) {
        if (val2.attribute_name === 'responder_sub_category') {
          this.respondertypes = val2.attribute_mvalue;
        }
        if (this.respondertypes) {
          this.responderTypes = [];
          this.respondertypes.forEach(val => {
            this.responderTypes.push(val.trim().toLowerCase());
          });
          if (this.responderTypes.indexOf(this.jobfunction.toLowerCase()) !== -1) {
            this.orgIdSelected = val1.orgid;
            search.done = true;
          }
        }
      }
    });
  }
  shouldShowOrgInfoUI(): boolean {
    return this.isOraEnabled() || !this.isDomainListEmpty();
  }

  isOraEnabled(): boolean {
    return this.oraInformation?.ora_required === 'Y';
  }

  getRetailManagerRole() {
    // Assigning the retail agent role from headers
    this.retailAgentGroup = 'G_FN_AGT_RS';
    const agentGroup = {
      retailAgentGroup: this.retailAgentGroup
    };
    const restURL = `${this.urlUtil.formatURlParams(CFETILMEndpointsConstant.FETCH_ORG_BY_GROUP, agentGroup)}`;
    this.cfetService.cfetLiveGet('', restURL).subscribe((data: any) => {
      // Move the scroll bar to top
      window.scrollTo(0, 0);
      try {
      // Data from the service call
      if (data) {
        this.organizationInfo = {};
          let orgMatched = false;
        data.forEach(orgInfo => {
          if (orgInfo.orgid === this.orgIdSelected) {
              orgMatched = true;
            this.createOrganizationsData(orgInfo, this.orgIdSelected);
          }
        });
          if (!orgMatched) {
            // Selected org wasn't found in the retail agent group - stop the spinner instead of hanging forever.
            this.handleOrgSearchError();
          }
      } else {
          this.handleOrgSearchError();
        }
      } catch (e) {
        this.handleOrgSearchError();
      }
    },
      (_error) => this.handleOrgSearchError());
    window.scrollTo(0, 0);
  }

  cancelCreation(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
        this.url = JSON.parse(sessionStorage.getItem('returnUrl'));
        if (this.isEncoded(this.url)) {
          this.redirectUrl(decodeURIComponent(this.url));
        } else {
          this.redirectUrl(this.url);
        }
      } else {
        // Redirect to the landing page
        this.router.navigate([CfetPageNamesConstant.CUSTOMER_LANDING]);
      }
    }
  }

  isEncoded(url) {
    if (url != '') {
      return url !== decodeURIComponent(url);
    }
  }

  goToDocUpload(event) {
    if (event) {
      this.showVerificationPending = false;
      this.progressTrackerEvent.emit('verified');
      this.showDocUploadSection = true;
    }
  }

  goToDocReceived(event) {
    if (event) {
      this.showDocUploadSection = false;
      this.showDocReviewPending = true;
      this.progressTrackerEvent.emit('Activation');
    }
  }

  redirectToLogin(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      const url = environment.loginURL;
      this.redirectUrl(url);
    }
  }

  redirectUrl(url) {
    window.location.href = url;
  }

  setNewSession(event) {
    if (event) {
      // No action needed : Emit true
    }
  }

  displayCancelModal(event) {
    if (event) {
      this.showCancelModal.emit(true);
    }
  }

  cancelModal(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showBeforeSheerIDCancelModal = true;
      this.openCancelModal = 'open';
    }
  }

  closeModal(event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }

  checkOraRequiredAttribute(attribute: string): boolean {
    if (!this.oraInformation) {
      return true;
    }

    const { ora_required: oraRequired, ora_required_attributes: oraRequiredAttributes } = this.oraInformation;

    if (oraRequired === 'N') {
      return true;
    }

    if (oraRequired === 'Y' && oraRequiredAttributes.includes(attribute)) {
      const controlName = attribute === 'employeeId' ? 'workidnumber' : 'workEmailAddress';
      const control = this.personalInformationFormGroup.get(controlName);

      if (control) {
        control.setValidators([Validators.required]);
        control.updateValueAndValidity();
      }

      return false;
    }

    return true;
  }
}
